import WrapperIonModal from "../../../../Components/ionic/WrapperIonModal";
import WrapperIonInput from "../../../../Components/ionic/WrapperIonInput";
import WrapperIonButton from "../../../../Components/ionic/WrapperIonButton";
import get from "lodash/get";
import React, {useEffect, useState} from "react";
import {useHistory} from 'react-router-dom';
import {
    addingNewContactRequestStart,
    addingNewContactToggleModal,
    addingNewContactTouchForm, importNewContactsRequestStart, importNewContactsToggleModal, importNewContactsTouchForm,

} from "../../../../actions/Chats";
import {connect} from "react-redux";
import {useTranslation} from "react-i18next";
import {addContact} from "../../../../thunks/Chats";
import {Toast} from '@capacitor/toast';


const ChatsWrapper = (
    {
        isOpen,
        setIsOpen,
        addContact,
        activeShop,
        contactName = '',
        contactPhone = ''
    }
) => {
    const {t, i18n} = useTranslation();
    let history = useHistory();

    // State


    // --------------------------
    // Hooks
    // --------------------------
    // componentDidMount && componentWillUnmount


    const isMobile = true;

    const [addingNewContactPhone, setAddingNewContactPhone] = useState('');
    const [addingNewContactName, setAddingNewContactName] = useState('');
    const [addingNewContactStateModal, setAddingNewContactStateModal] = useState('');

    useEffect(() => {
        setAddingNewContactPhone(contactPhone);
        setAddingNewContactName(contactName);
    }, [contactName, contactPhone]);

    useEffect(() => {
        if (!addingNewContactStateModal) {
            setAddingNewContactPhone('');
            setAddingNewContactName('');
        }
    }, [addingNewContactStateModal]);


    const clearDataAndClose = (data) => {
        setIsOpen(data);
        setAddingNewContactPhone('');
        setAddingNewContactName('');

    }

    const sendAddingNewContactRequest = async (e) => {
        e.preventDefault();
        let res = await addContact(addingNewContactName.replace(/\s+/g, ' ').trim(), addingNewContactPhone.replace(/[^+\d]/g, ''))
        if (res.status) {
            setIsOpen(false);
            history.push(`/${activeShop.id}/chat/${res.data.chat_id}/`);
        } else {
            await Toast.show({
                text: get(res, 'common')
            });
        }
    }


    return <WrapperIonModal
        isOpen={isOpen}
        toggle={clearDataAndClose}
        title={t('chats.modal_adding_new_contact.adding_a_new_contact', "Adding a new contact")}>
        <form onSubmit={sendAddingNewContactRequest} autoComplete="on" style={{padding: '10px'}}>
            <WrapperIonInput
                label={`${t('chats.modal_adding_new_contact.phone_number', "Phone number")} *`}
                placeholder={t('chats.modal_adding_new_contact.phone', "Phone")}
                value={addingNewContactPhone}
                Change={setAddingNewContactPhone}
                required={true}
            />
            <WrapperIonInput
                label={t('chats.modal_adding_new_contact.contact_name', "Contact name")}
                placeholder={t('chats.modal_adding_new_contact.name', "Name")}
                value={addingNewContactName}
                Change={value => setAddingNewContactName(value.replace(/\s+/g, ' ').trim())}

            />
            <WrapperIonButton
                title={t('chats.modal_adding_new_contact.send_in', "Send in")}
                type="submit"
                disabled={addingNewContactPhone.length < 11 || addingNewContactName === ''}
            />
        </form>
    </WrapperIonModal>
}


const mapStateToProps = state => ({
    activeShop: state.Shops.activeShop,
});

const mapDispatchToProps = dispatch => ({

    addContact: (phone, name) => dispatch(addContact(phone, name)),

});

export default connect(mapStateToProps, mapDispatchToProps)(ChatsWrapper);
